export const pickFields = <T extends Record<string, unknown>, K extends keyof T | string>(
  obj: T,
  ...keys: K[]
): Pick<T, K> => Object.fromEntries(keys.filter((key) => key in obj).map((key) => [key, obj[key]])) as Pick<T, K>;
